import ProfileService from "../services/profileService";
export const updateCompanyDetails = (companyDetails) => {
  return {
    type: "UPDATE_COMPANY_DETAILS",
    companyDetails,
  };
};

export const updateEmployeeDetails = (employeeDetails) => {
  return {
    type: "UPDATE_EMPLOYEE_DETAILS",
    employeeDetails,
  };
};

export const checkForAwardMenu = (awardCheck) => {
  return {
    type: "CHECK_FOR_AWARD_MENU",
    awardCheck,
  };
};
export const checkForActiveIntegration = (activeIntegration) => {
  return {
    type: "CHECK_FOR_ACTIVE_INTEGRATION",
    activeIntegration,
  };
};
export const checkForAllIntegrations = (allIntegrations) => {
  return {
    type: "CHECK_FOR_ALL_INTEGRATIONs",
    allIntegrations,
  };
};
export const updatePlumProPoints = (plumProPoints) => {
  return {
    type: "UPDATE_PLUM_PRO_POINTS",
    plumProPoints,
  };
};

export const updateUserBalance = (userBalance) => {
  return {
    type: "UPDATE_USER_BALANCE",
    userBalance,
  };
};

export const updateClientId = (clientId) => {
  return {
    type: "UPDATE_CLIENT_ID",
    clientId,
  };
};
export const updateKybStatus = (kybStatus) => {
  return {
    type: "UPDATE_KYB_STATUS",
    kybStatus,
  };
};
export const updateShowCts = (showCts) => {
  return {
    type: "UPDATE_SHOW_CTS",
    showCts,
  };
};
export const updateXoxoPoints = (xoxoPoints) => {
  return {
    type: "UPDATE_XOXO_POINTS",
    xoxoPoints,
  };
};

export const updateModuleAccessList = (moduleAcl) => {
  return {
    type: "UPDATE_MODULE_ACCESS_LIST",
    moduleAcl,
  };
};

export const updateUserAndCompanyType = (typeData) => {
  return {
    type: "UPDATE_USER_AND_COMPANY_TYPE",
    typeData,
  };
};

export const updatePlatformSettings = (platformSettings) => {
  return {
    type: "UPDATE_PLATFORM_SETTINGS",
    platformSettings,
  };
};

export const updateDistributionType = (distributionType) => {
  return {
    type: "UPDATE_DISTRIBUTION_TYPE",
    distributionType,
  };
};
export const updateCcRechargeAllowed = (ccRechargeAllowed) => {
  return {
    type: "UPDATE_CC_RECHARGE_ALLOWED",
    ccRechargeAllowed,
  };
};
export const updateMFAData = (MFAData) => {
  return {
    type: "UPDATE_MFA_DATA",
    MFAData,
  };
};

export const updateAllowOnlineTransfer = (allowOnlineTransfer) => {
  return {
    type: "UPDATE_ALLOW_ONLINE_TRANSFER",
    allowOnlineTransfer,
  };
};

export const updateAllowedDomains = (allowedDomains) => {
  return {
    type: "UPDATE_ALLOWED_DOMAINS",
    allowedDomains,
  };
};

export const updateUserBalanceByThunk = () => (dispatch) => {
  ProfileService.userBalance({})
    .then((response) => {
      if (
        response &&
        response.getVoucherBalance &&
        response.getVoucherBalance.error == false
      ) {
        let data = {
          currencySymbol:
            response.getVoucherBalance.data.formatted["currencySymbol"],
          userBalance: response.getVoucherBalance.data.formatted["balance"],
          companyBalance:
            response.getVoucherBalance.data.formatted["companyBalance"],
          currencyValue:
            response.getVoucherBalance.data.formatted["currencyValue"],
          currencyCode:
            response.getVoucherBalance.data.formatted["currencyCode"],
        };
        dispatch(updateUserBalance(data));
      }
    })
    .catch((error) => {});
};
